import { api } from '../../lib/api';
import type { ActivityPage } from './types';

/**
 * Activity transport.
 *
 * ── ASSUMED CONTRACT ──────────────────────────────────────────────────────
 *   GET /workspaces/:workspaceId/activity                       -> ActivityPage
 *   GET /workspaces/:workspaceId/requests/:requestId/activity   -> ActivityPage
 *
 * Both endpoints apply the client/internal split server-side (see
 * activity.service.ts); nothing here filters a response that already arrived.
 */

export interface ActivityQuery {
  readonly limit?: number;
  readonly cursor?: string;
}

function toParams(query: ActivityQuery): string {
  const params = new URLSearchParams();
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  if (query.cursor !== undefined) params.set('cursor', query.cursor);
  const qs = params.toString();
  return qs === '' ? '' : `?${qs}`;
}

export function fetchWorkspaceActivity(
  workspaceId: string,
  query: ActivityQuery = {},
  signal?: AbortSignal,
): Promise<ActivityPage> {
  return api.get<ActivityPage>(
    `/workspaces/${encodeURIComponent(workspaceId)}/activity${toParams(query)}`,
    signal,
  );
}

export function fetchRequestActivity(
  workspaceId: string,
  requestId: string,
  query: ActivityQuery = {},
  signal?: AbortSignal,
): Promise<ActivityPage> {
  return api.get<ActivityPage>(
    `/workspaces/${encodeURIComponent(workspaceId)}/requests/${encodeURIComponent(requestId)}/activity${toParams(query)}`,
    signal,
  );
}
